// libs
import React, { memo } from "react";

// components
import FakeScroller from "shared/components/FakeScroller";

// styles
import { Container, SubCategory } from "./styles";

interface ISubCategoriesProps {
    data: IMapOfString[];
}

function SubCategories({ data }: ISubCategoriesProps) {
    return (
        <Container>
            <div className="sc-inner">
                <FakeScroller>
                    <div>
                        {data.map((children, idx: number) => (
                            <SubCategory bigItem key={idx} data={children} />
                        ))}
                    </div>
                </FakeScroller>
            </div>
        </Container>
    );
}

export default memo(SubCategories);
